var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCursorClick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6506 7.05594C11.9267 7.05594 12.1506 6.83209 12.1506 6.55594V4.5C12.1506 4.22386 11.9267 4 11.6506 4H10.6133C10.3371 4 10.1133 4.22386 10.1133 4.5V6.55594C10.1133 6.83209 10.3371 7.05594 10.6133 7.05594H11.6506Z",
    fill: "#8494AE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.16215 5.89563C4.96688 6.09089 4.96688 6.40747 5.16215 6.60274L7.00166 8.44225C7.19692 8.63751 7.5135 8.63751 7.70876 8.44225L8.44225 7.70876C8.63751 7.5135 8.63751 7.19692 8.44225 7.00166L6.60274 5.16215C6.40747 4.96688 6.09089 4.96688 5.89563 5.16215L5.16215 5.89563Z",
    fill: "#8494AE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1124 9.09375L9.09375 10.1124L12.0357 18.9383C12.1038 19.1425 12.2949 19.2802 12.5101 19.2802H13.7966C14.026 19.2802 14.226 19.1241 14.2817 18.9015L14.9176 16.3581L18.2064 19.647C18.4017 19.8422 18.7182 19.8422 18.9135 19.647L19.647 18.9135C19.8422 18.7182 19.8422 18.4017 19.647 18.2064L16.3581 14.9176L18.9015 14.2817C19.1241 14.226 19.2802 14.026 19.2802 13.7966V12.5101C19.2802 12.2949 19.1425 12.1038 18.9383 12.0357L10.1124 9.09375Z",
    fill: "#8494AE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 10.6133C4 10.3371 4.22386 10.1133 4.5 10.1133H6.55594C6.83209 10.1133 7.05594 10.3371 7.05594 10.6133V11.6506C7.05594 11.9267 6.83209 12.1506 6.55594 12.1506H4.5C4.22386 12.1506 4 11.9267 4 11.6506V10.6133Z",
    fill: "#8494AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCursorClick);
export default __webpack_public_path__ + "static/media/cursor-click.8b7f4ccfedb42e6d3466565f52b373ab.svg";
export { ForwardRef as ReactComponent };